import { BadRequestError } from '@cian/valuation-utils-component';

import {
  fetchGetUserAnswersFromHistory,
  TGetUserAnswersFromHistoryResponse,
  TGetUserAnswersFromHistoryRequest,
} from '../../repositories/price-estimator/v2/get-user-answers-from-history';
import { TThunkAction } from '../../types/redux';
import { setEstimationReady } from './actions';

export function checkEstimationForUser(): TThunkAction<Promise<boolean>> {
  return async (dispatch, getState, context) => {
    const { httpApi, logger } = context;
    const {
      filters: { roomsCount, area, houseId },
    } = getState();

    try {
      const res = (await fetchGetUserAnswersFromHistory({
        httpApi,
        parameters: {
          roomsCount: roomsCount as TGetUserAnswersFromHistoryRequest['roomsCount'],
          area: area as number,
          houseId: houseId as number,
        },
      })) as TGetUserAnswersFromHistoryResponse;

      if (res.statusCode === 200 && res.response.estimationId) {
        dispatch(
          setEstimationReady({
            estimationId: res.response.estimationId,
            offer: res.response.offer,
          }),
        );

        return true;
      }

      if (res.statusCode !== 200) {
        const error = new BadRequestError({
          domain: 'checkEstimationForUser.ts',
          message: res.response.message as string,
          details: {
            errors: JSON.stringify(res.response.errors),
          },
        });

        logger.warning(error, { roomsCount, area, houseId });
      }

      return false;
    } catch (e) {
      logger.error(e, { message: 'Failed get v2/get-user-answers-from-history' });

      return false;
    }
  };
}
